import { render, staticRenderFns } from "./PaycheckImpact.vue?vue&type=template&id=648b4d64&"
import script from "./PaycheckImpact.vue?vue&type=script&lang=js&"
export * from "./PaycheckImpact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports